const vaildate = function (name, data, rules, callback) {
  if (Array.isArray(rules)) {
    for (let i = 0; i < rules.length; i++) {
      switch (rules[i].type) {
        case 'required':
          if (data === '' || data === undefined || data === null || data.length === 0) {
            if (typeof callback === 'function') {
              if (!rules[i].message) {
                rules[i].message = name + '是必填项'
              }
              callback(rules[i].message)
              return false
            }
          }
          break
        case 'phone':
          if (!/^134[0-8]\d{7}$|^13[^4]\d{8}$|^14[5-9]\d{8}$|^15[^4]\d{8}$|^16[6]\d{8}$|^17[0-8]\d{8}$|^18[\d]{9}$|^19[8,9]\d{8}$/.test(data)) {
            if (typeof callback === 'function') {
              if (!rules[i].message) {
                rules[i].message = name + '不正确'
              }
              callback(rules[i].message)
              return false
            }
          }
          break
        case 'name':
          if (!/^([a-zA-Z0-9\u4e00-\u9fa5·]{1,10})$/.test(data)) {
            if (typeof callback === 'function') {
              if (!rules[i].message) {
                rules[i].message = name + '不正确'
              }
              callback(rules[i].message)
              return false
            }
          }
          break
        case 'idcard':
          if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(data)) {
            if (typeof callback === 'function') {
              if (!rules[i].message) {
                rules[i].message = name + '不正确'
              }
              callback(rules[i].message)
              return false
            }
          }
          break
        case 'servicepwd':
          if (!/^\d{6}$/.test(data)) {
            if (typeof callback === 'function') {
              if (!rules[i].message) {
                rules[i].message = name + '不正确'
              }
              callback(rules[i].message)
              return false
            }
          }
          break
        case 'vincode':
          if (!/(?!^\d+$)(?!^[a-zA-Z]+$)[0-9a-zA-Z]{17}/.test(data)) {
            if (typeof callback === 'function') {
              if (!rules[i].message) {
                rules[i].message = name + '不正确'
              }
              callback(rules[i].message)
              return false
            }
          }
          break
        default:
          break
      }
    }
    return true
  }
}

export default vaildate



// WEBPACK FOOTER //
// ./src/utils/vaildate.js